import React, { useState, useEffect } from 'react';
import { Col, Row } from '../../../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTOWithCol from '../../../../../components/fields/Abstract/FieldDTOWithCol';
import TextInputWithLabel from '../../../../../components/fields/TextInput/TextInputWithLabel';
import Switches from '../../../../../components/fields/Switches/Switches';
import { quotesTransform } from '../../../../../utils/utils';
import ApplicantDTO from '../../../../../dto/ApplicantDTO';
import FileInput from '../../../../../components/fields/FileInput/FileInput';
import { PROCEDURE_TYPE, USER_TYPE } from '../../../../../configs';

export default function ServiceMarkForm(props) {
  const {
    prefix = 'applicant_new.',
    control,
    formMeta,
    applicantType,
    procedure,
    isEdit = false,
    currentApplication = {},
    setValue,
    getValues,
  } = props;

  const [showServiceMark, setShowServiceMark] = useState(
    isEdit ? !!currentApplication?.applicant_new?.logo_files || currentApplication?.applicant_new?.logo_files === null : false,
  );
  const [showCommercialName, setShowCommercialName] = useState(
    isEdit ? !!currentApplication?.applicant_new?.commercial_name || currentApplication?.applicant_new?.commercial_name === null : false,
  );

  const dto = new ApplicantDTO();
  const attributes = dto.getAttributesByName();

  useEffect(() => {
    setValue('applicant_new.logo_files', !showServiceMark ? null : (isEdit ? getValues('applicant_new.logo_files') || '' : ''));
  }, [showServiceMark]);

  useEffect(() => {
    setValue('applicant_new.commercial_name', !showCommercialName ? null : (isEdit ? getValues('applicant_new.commercial_name') || '' : ''));
    if (!showCommercialName) {
      setValue('media.commercial_change_document', null);
    }
  }, [showCommercialName]);

  const isValidProcedure = [PROCEDURE_TYPE.PROCEDURE_1227_3, PROCEDURE_TYPE.PROCEDURE_1228_3].includes(procedure);
  const isValidApplicantType = [USER_TYPE.LEGAL, USER_TYPE.INDIVIDUAL_ENTREPRENEUR].includes(applicantType);

  if (!isValidProcedure || !isValidApplicantType) {
    return null;
  }

  return (
    <>
      <div className="f4 mt-3">Изменился знак обслуживания и/или коммерческое обозначение</div>

      <Row className="row-cols-1">
        <Col>
          <Switches
            type="text"
            variant="material"
            inputProps={{
              onChange: () => setShowServiceMark(!showServiceMark),
              value: showServiceMark,
            }}
            label="Изменился знак обслуживания"
          />
        </Col>
      </Row>
      {showServiceMark && (
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.logo_files}
            variant="material"
            transform={quotesTransform}
            namePrefix={prefix}
            labelPrefix="new."
          />
        </Row>
      )}

      <Row className="row-cols-1">
        <Col>
          <Switches
            type="text"
            variant="material"
            inputProps={{
              onChange: () => setShowCommercialName(!showCommercialName),
              value: showCommercialName,
            }}
            label="Изменилось коммерческое обозначение"
          />
        </Col>
      </Row>
      {showCommercialName && (
        <Row className="row-cols-2">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.commercial_name}
            variant="material"
            transform={quotesTransform}
            namePrefix={prefix}
            labelPrefix="new."
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={FileInput}
            dtoObject={attributes.commercial_change_document}
            variant="material"
            namePrefix="media."
          />
        </Row>
      )}

      <div className="hr-row mt-3" />
    </>
  );
}
